/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function addEventListenerStamped(el, eventName, handler) { 
   if (el.addEventListener) { el.addEventListener(eventName, handler); }
   else { el.attachEvent('on' + eventName, function () { handler.call(el); }); } 
}


// Example
// Listening for reviews widget loaded event
addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {
  $(".stamped-thank-you p:nth-child(1)").text("レビューを送信していただきありがとうございます。");
  $(".stamped-thank-you p:nth-child(2)").text("商品の感想をSNSでお友達にシェアしていただけますと幸いです。");
  $(".stamped-form-contact-name .stamped-form-input").attr('placeholder', 'ニックネーム（一般公開されます）');
  $(".stamped-form-contact-name .stamped-form-label").text('ニックネーム');
  $(".stamped-form-contact-email .stamped-form-input").attr('placeholder', 'sample@gmail.com（非公開／ご連絡用）');
  $(".stamped-form-review-title .stamped-form-input").attr('placeholder', 'タイトルを入力してください。');
  $(".stamped-form-review-body .stamped-form-label").text('商品のご感想');
  $(".stamped-form-review-body .stamped-form-input").attr('placeholder', '商品の感想を入力してください。');
  $("#stamped-button-submit").attr('value', 'レビューを投稿する');
  
});
